<template>
  <crud-base
    :title="title"
    :popup-data="popupData"
    :show-popup="showPopup"
    @cancel="returnToList()"
    @add-register="save"
    @ok="returnToList"
  >
    <template v-slot:form>
      <div class="flex-auto lg:px-2 py-2 pt-4">
        <form>
          <div class="flex flex-wrap">
            <div class="w-full lg:w-6/12 px-2">
              <custom-input
                name="name"
                :label="$t('forms.userGroup.fields.name')"
                :disabled="isOnlyView"
                type="text"
                :placeholder="$t('forms.userGroup.fieldsPlaceholder.name')"
                v-model="$store.state.groups.form.name"
                validate="required"
              />
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="w-full lg:w-12/12 px-2">
              <h6
                class="text-blueGray-400 text-sm mt-1 mb-1 font-bold uppercase"
              >
                {{ $t("forms.userGroup.permissionsTitle") }}
              </h6>
              <permissions />
            </div>
          </div>
        </form>
      </div>
    </template>
  </crud-base>
</template>
<script>
import CrudBase from "@/components/Cards/CrudBase.vue";
import Permissions from "@/views/users/Permissions.vue";
import CustomInput from "@/components/Inputs/CustomInput.vue";
import { baseMixin } from "@/mixins/base";
import { mapActions } from "vuex";

export default {
  components: {
    CrudBase,
    Permissions,
    CustomInput,
  },
  async created() {
    this.isLoading = !this.isLoading;
    this.setShowOverlay(this.isLoading);

    this.$store.state.popup.show = false;
    this.getPageTitle();

    await this.getPermissionList({
      search: null,
      page: 1,
      pageSize: -1,
    });
    this.$route.params.id ? await this.loadData() : this.initForm();

    this.isLoading = !this.isLoading;
    this.setShowOverlay(this.isLoading);
  },
  mixins: [baseMixin],
  data() {
    return {
      module: "userGroup",
      capitalizeModule: "UserGroup",
      listName: "ListUserGroups",
    };
  },
  methods: {
    ...mapActions([
      "getPermissionList",
      "getUserGroupById",
      "setAddedPermissions",
      "saveGroup",
      "setShowOverlay",
    ]),
    initForm() {
      this.$store.state.groups.form = {
        name: null,
        permissions: [],
      };
    },
    async loadData() {
      await this.getUserGroupById({ id: this.$route.params.id });
      await this.setAddedPermissions();
    },
    async save() {
      try {
        this.setShowOverlay(true);

        const res = await this.saveGroup();
        const data = await res.json();

        this.setShowOverlay(false);
        const isOk = res.status >= 200 && res.status <= 300;

        this.popupData = {
          show: true,
          type: isOk ? "success" : "error",
          title: isOk
            ? this.$t("popup.success.title")
            : this.$t("popup.error.title"),
          message: isOk
            ? this.$t("popup.success.message")
            : data.non_field_errors[0],
        };
        this.showPopup = true;
      } catch (error) {
        this.setShowOverlay(false);
        this.popupData = {
          show: true,
          type: "error",
          title: this.$t("popup.error.title"),
          message: this.$t("popup.error.message"),
        };
        this.showPopup = true;
      }
    },
  },
};
</script>
